export const CYAN = "cyan";


